import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from '@mui/material';

export const TextField = MuiTextField;
export type TextFieldProps = MuiTextFieldProps;
